import { Reveal, SectionLabel } from "./Reveal";
import { MANIFESTO } from "../data/clinic";

export const Manifesto = () => (
  <section
    id="approach"
    data-testid="manifesto-section"
    className="py-24 sm:py-32 bg-sa-cream"
  >
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <div className="max-w-3xl">
        <Reveal>
          <SectionLabel testId="manifesto-label">Our approach</SectionLabel>
        </Reveal>
        <Reveal delay={0.1}>
          <h2 className="font-display font-light text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight text-sa-espresso mt-6">
            Your pet deserves more than treatment.
            <span className="italic text-sa-bronze"> They deserve care.</span>
          </h2>
        </Reveal>
        <Reveal delay={0.15}>
          <p className="font-body text-base sm:text-lg text-sa-mocha mt-6 leading-relaxed">
            We know how much your companion means to you. Here&rsquo;s how we
            look after them — with warmth, honesty and expertise, at every hour.
          </p>
        </Reveal>
      </div>

      <div className="mt-16 sm:mt-20 grid md:grid-cols-3 gap-x-10 gap-y-14">
        {MANIFESTO.map((chapter, i) => (
          <Reveal key={chapter.no} delay={i * 0.12}>
            <div
              className="border-t border-sa-espresso/15 pt-6"
              data-testid={`manifesto-chapter-${chapter.no}`}
            >
              <span className="font-display text-5xl sm:text-6xl font-light text-sa-bronze/40">
                {chapter.no}
              </span>
              <h3 className="font-display text-2xl sm:text-3xl text-sa-espresso mt-4 mb-3">
                {chapter.title}
              </h3>
              <p className="font-body text-base text-sa-mocha leading-relaxed">
                {chapter.body}
              </p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default Manifesto;
